export {
  default as IdentitySearchResults,
  type TIdentitySearchResultsProps,
} from './IdentitySearchResults';
export { type TSearchResultProps } from './SearchResult';
export * from './types';
